import { ListTicketLinksRequest, ListTicketLinksResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export type LinkedTicketPreview = ListTicketLinksResponse[0];
export const listTicketLinks = makeCloudFunction<ListTicketLinksRequest, ListTicketLinksResponse>(
  "ticketLink",
  "listTicketLinks",
);
